'use strict';

(function (global) {

  /**
   * @class ImageDocumentPostprocessor
   * @classdesc Подготовка к предпросмотру изображений.
   * @hideconstructor
   * @namespace window.Core.preview
   * @since 5.7.0
   */
  class MultipageDocumentPostprocessor extends global.BaseDocumentPostprocessor {

    // Костыль для IE10, иначе он не может наследовать родительский static метод с babel-preset-env 1.6.1
    /**
     * @see BaseDocumentPostprocessor.prepare
     */
    static prepare(jFrame, filePath, extension) {
      return super.prepare(jFrame, filePath, extension);
    }

    // Костыль для IE10, иначе он не может наследовать родительский static метод с babel-preset-env 1.6.1
    /**
     * @see BaseDocumentPostprocessor._addFilesToHead
     */
    static _addFilesToHead(jFrameContents, filePath) {
      return super._addFilesToHead(jFrameContents, filePath);
    }

    /**
     * @see BaseDocumentPostprocessor._prepareContents
     */
    static _prepareContents(jFrame) {
      const jImage = jFrame.contents().find('img:first');
      if (!jImage.attr('initHeight')) {
        jImage.attr('initHeight', jImage[ 0 ].naturalHeight || jImage.height());
      }
      if (!jImage.attr('initWidth')) {
        jImage.attr('initWidth', jImage[ 0 ].naturalWidth || jImage.width());
      }
      jImage.addClass('previewImage');

      if (this._isIpad && jFrame.parent().attr('id') !== 'preview-scroller') {
        const scrollerStyle = [
          '-webkit-overflow-scrolling: touch;',
          `height: ${$(window).height() - jFrame.offset().top}px;`,
          'overflow: auto;',
        ];
        jFrame.wrap(`<div id="preview-scroller" style="${scrollerStyle.join(' ')}"></div>`);
      }
    }
  }

  global.MultipageDocumentPostprocessor = MultipageDocumentPostprocessor;

})(window.Core.preview);